import { useHttp } from 'shared/providers/provide-http';
import { BackendFilterModel, ExportPriceDTO } from 'types/backend';

export function useGetExportDeviations() {
    const http = useHttp();

    const getDeviations = async (customerNumber: string, increaseValue: number | undefined, filtersApplied: BackendFilterModel | undefined): Promise<ExportPriceDTO[]> => {
        if (!filtersApplied) {
            filtersApplied = { items: [] };
        }

        if (!filtersApplied.items.some(f => f.columnField.toLowerCase() === 'pricetype')) {
            filtersApplied.items.push(
                {
                    columnField: 'priceType',
                    operatorValue: 'contains',
                    value: 'Deviation'
                });
        }
        if (!filtersApplied.items.some(f => f.columnField.toLowerCase() === 'status')) {
            filtersApplied.items.push(
                {
                    columnField: 'status',
                    operatorValue: 'contains',
                    value: 'Approved'
                });
        }
        const { data } = await http.post(`api/DistributorExportPrices/subset/${customerNumber}`, {
            request: {
                FilterModel: filtersApplied,
                SortModel: [],
                pageSize: 0
            },
            increaseValue
        });
        return data || [];
    };

  return {getDeviations};
}
